import React from 'react'

const Icon = (props) => {
    return (
        <div className='icon' {...props}>
            <img src={props.src} alt='' />
        </div>
    )
}

export default Icon



// WEBPACK FOOTER //
// ./resources/js/components/Icon.js